import { useEffect, useState } from 'react';

/**
 * Bridges the service worker's update event into React.
 *
 * Registration starts in main.jsx before the first render, so the "a new build
 * is waiting" event can arrive before any component exists to hear it. This
 * module-level store holds the activate callback until something subscribes.
 */

let activateFn = null;
let dismissedThisSession = false;
const listeners = new Set();

const emit = () => { listeners.forEach((fn) => fn()); };

/** Called from registerServiceWorker's onUpdateReady. */
export const setUpdateReady = (activate) => {
    activateFn = activate;
    dismissedThisSession = false;
    emit();
};

const useServiceWorkerUpdate = () => {
    const [, force] = useState(0);

    useEffect(() => {
        const sync = () => force((n) => n + 1);
        listeners.add(sync);
        return () => { listeners.delete(sync); };
    }, []);

    return {
        updateReady: Boolean(activateFn) && !dismissedThisSession,
        // The page reloads on the worker's controllerchange event, so there is
        // nothing to do here beyond firing the message.
        applyUpdate: () => { activateFn?.(); },
        dismissUpdate: () => { dismissedThisSession = true; emit(); },
    };
};

export default useServiceWorkerUpdate;
